import {
  START_DRAW,
  STOP_DRAW,
  CLEAN_DRAW,
  MODIFY_DRAW,
  CLEAN_MODIFY_DRAW,
  ADD_FEATURE_LAYER_TO_MAP,
} from './actionTypes';
import { removeFeatureLayerFromMap } from './layersFeature';
import {
  startDrawService,
  stopDrawService,
  cleanDrawService,
  modifyDrawService,
  cleanModifyService,
} from '../../utils/draw.modify';

export const startDraw = (map, type, free) => (dispatch, getState) => {
  startDrawService(map, type, free)
    .then((vectorDraw) => {
      dispatch({
        type: START_DRAW,
      });
      
      // Sadece çizim katmanı state'de yoksa ekle
      const layersFeature = getState().layersFeature;
      const existingDrawLayer = layersFeature.find(layer => 
        layer.get('title') === 'Çizim Katmanı'
      );
      
      if (!existingDrawLayer) {
        dispatch({
          type: ADD_FEATURE_LAYER_TO_MAP,
          payload: vectorDraw,
        });
      }
    })
    .catch((err) => {});
};
export const stopDraw = (map) => (dispatch) => {
  stopDrawService(map);
  dispatch({
    type: STOP_DRAW,
  });
};
export const cleanDraw = (map) => (dispatch, getState) => {
  // Haritadan temizle
  cleanDrawService(map);
  
  // Redux state'den de temizle
  const layersFeature = getState().layersFeature;
  const drawLayer = layersFeature.find(layer => 
    layer.get('title') === 'Çizim Katmanı'
  );
  
  if (drawLayer) {
    dispatch(removeFeatureLayerFromMap(drawLayer));
  }
  
  dispatch({
    type: CLEAN_DRAW,
  });
};
export const modifyDraw = (map) => (dispatch) => {
  modifyDrawService(map);
  dispatch({
    type: MODIFY_DRAW,
  });
};

export const cleanModifyDraw = (map) => (dispatch) => {
  cleanModifyService(map);
  dispatch({
    type: CLEAN_MODIFY_DRAW,
  });
};
